import {observable} from "mobx";
import {RelatorioService} from "../../../services";
import {getMensagemDeErro} from "../../../utils/functions";
import fileDownload from "../../comum/components/FileDownload";

export default class AuditoriaAcessoCrachaLiberacaoPeriodoMOTStore {
    @observable erro;
    @observable carregando;
    @observable dados;

    constructor() {
        this.relatorioService = new RelatorioService();
    }

    filtrar = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.findAuditoriaAcessoCrachaLiberacaoPeriodoMOT(filtro).then(response => {
            this.dados = response.data;
            
            this.carregando = false;
        }).catch(error => {
            this.erro = getMensagemDeErro(error);
            this.carregando = false;
        });
    }

    onExportExcel = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaAcessoCrachaLiberacaoPeriodoMOTExcel(filtro).then(response => {
            fileDownload(response.data, "Auditoria acessos, crachás e liberações pós período MOT.xlsx");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }

    onExportPdf = (filtro) => {
        this.carregando = true;
        this.erro = null;

        this.relatorioService.downloadAuditoriaAcessoCrachaLiberacaoPeriodoMOTPdf(filtro).then(response => {
            fileDownload(response.data, "Auditoria acessos, crachás e liberações pós período MOT.pdf");

            this.carregando = false;
        }).catch(error => {
            this.erro = "Nenhum resultado encontrado";
            this.carregando = false;
        });
    }
}
